import type { RouteGroup } from "@/app/routes";
import type { IconComponent } from "@/shared/layout";
import {
  BarChart3,
  CreditCard,
  LayoutDashboard,
  Megaphone,
  Palette,
  PlugZap,
  SlidersHorizontal,
} from "@/shared/ui/icons";

export interface NavigationItem {
  to: string;
  key: string;
  icon: IconComponent;
}
export interface NavigationGroup {
  key: "overview" | "improve" | "configuration" | "administration";
  items: NavigationItem[];
}

export const NAVIGATION_GROUPS: readonly NavigationGroup[] = [
  {
    key: "overview",
    items: [
      { to: "/dashboard", key: "dashboard", icon: LayoutDashboard },
      { to: "/analytics", key: "analytics", icon: BarChart3 },
    ],
  },
  {
    key: "improve",
    items: [
      { to: "/fineTuning", key: "fineTuning", icon: SlidersHorizontal },
      { to: "/visualMachine", key: "visualMachine", icon: Megaphone },
      { to: "/layoutDesign", key: "layoutDesign", icon: Palette },
    ],
  },
  { key: "configuration", items: [{ to: "/setup", key: "setup", icon: PlugZap }] },
  { key: "administration", items: [{ to: "/billing", key: "billing", icon: CreditCard }] },
];

/** Sezioni raggiungibili anche senza shop: tutte le altre mostrano il Void che invita a crearne uno. */
export const SHOP_INDEPENDENT_GROUPS: ReadonlySet<RouteGroup> = new Set<RouteGroup>([
  "wizard",
  "billing",
  "account",
  "support",
  "terms",
]);
/** Gruppi in cui la barra SaveChanges non compare. */
export const SAVE_HIDDEN_GROUPS: ReadonlySet<RouteGroup> = new Set<RouteGroup>(["wizard", "billing"]);

/** Nome rotta -> suffisso di `shell.pages.*` (eyebrow, title, description). */
export const PAGE_PRESENTATION: Readonly<Record<string, string>> = {
  "wizard-start": "wizardStart",
  "wizard-cms": "wizardCms",
  "wizard-shop": "wizardShop",
  "wizard-settings": "wizardSettings",
  account: "account",
  "billing-overview": "billingOverview",
  "billing-plans": "billingPlans",
  "billing-information": "billingInformation",
  support: "support",
  fineTuning: "fineTuning",
  "visualMachine-campaigns": "campaigns",
  "visualMachine-banners": "banners",
  "visualMachine-recommendations": "recommendations",
  "layoutDesign-general": "layoutGeneral",
  "layoutDesign-desktop": "layoutDesktop",
  "layoutDesign-mobile": "layoutMobile",
  "layoutDesign-card": "layoutCard",
  "layoutDesign-builder": "layoutBuilder",
  "layoutDesign-customStyle": "layoutCustomStyle",
  dashboard: "dashboard",
  "analytics-overview": "analyticsOverview",
  "analytics-filters": "analyticsFilters",
  "analytics-queries": "analyticsQueries",
  "search-configuration": "searchConfiguration",
  "advanced-settings": "advancedSettings",
  terms: "terms",
};
